import React from "react";
import { Marker } from "react-leaflet";

const AutoOpenPopupMarker = props => {
  const init = ref => {
    if (ref) {
      ref.leafletElement.openPopup();
    }
  };

  return <Marker ref={init} {...props} />;
};

export default AutoOpenPopupMarker;


// WEBPACK FOOTER //
// ./src/AutoOpenPopupMarker.jsx